import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import { type UserResource, UserTypeEnum } from "@exonn/js-sdk";

export const module: ModuleOptions<UserResource> = {
  resource: ResourceEnum.User,
  bigIcon: <i className="icon-20-customers_adm" />,
  smallIcon: <i className="icon-15-customers_adm" />,
  list: {
    hideDeleteAction: (row) => {
      return [UserTypeEnum.Developer, UserTypeEnum.Owner].includes(
        row.user_type,
      );
    },
  },
  tabs: {
    edit: {
      titleProp: "name",
    },
  },
};
